<!-- 我的申请 -->
<template>
  <div>
    <div class="filter-container">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="isMB?11:16">
          <span class="span-top-text" style="line-height:39px;">查询条件</span>
          <div class="searchIcon" @click="showForm = !showForm">
            <i :class="showForm?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
          </div>
        </el-col>
        <el-col :span="isMB?13:8">
          <div class="btn-search">
            <el-button type="primary" icon="el-icon-search" @click="onQuery()">搜索</el-button>
            <el-button type="primary" plain @click="resetQuery">重置</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row v-show="showForm">
        <el-divider style="margin:0px;"></el-divider>
        <el-form
          label-width="85px"
          class="form-item"
          :class="{'form-item-left':isMB}"
          @keyup.enter.native="getData()"
        >
          <el-form-item label="流程名称">
            <el-select v-model="params.ProcessId" placeholder="请选择流程名称" clearable>
              <template v-for="(i,key) in Processes">
                <el-option :key="key" :label="i.ProcessName" :value="i.ProcessId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="params.Title" placeholder="请输入标题" />
          </el-form-item>
          <template v-if="!isMB">
            <el-form-item label="申请时间">
              <range-picker ref="picker1" @change="setDate($event,'Apply')" />
            </el-form-item>
            <el-form-item label="通过时间">
              <range-picker ref="picker2" @change="setDate($event,'Complete')" />
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="申请时间">
              <el-date-picker
                v-model="params.ApplyStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label-width="85px">
              <el-date-picker
                v-model="params.ApplyEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="通过时间">
              <el-date-picker
                v-model="params.CompleteStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label-width="85px">
              <el-date-picker
                v-model="params.CompleteEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </template>
          <el-form-item label="审批状态">
            <el-select v-model="params.Status" placeholder="请选择状态" clearable>
              <!-- <el-option label="草稿" :value="0"></el-option> -->
              <el-option label="审批中" :value="1"></el-option>
              <el-option label="已通过" :value="2"></el-option>
              <el-option label="已驳回" :value="3"></el-option>
              <el-option label="已撤销" :value="4"></el-option>
              <el-option label="通过后撤销" :value="5"></el-option>
              <el-option label="异常" :value="6"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row v-show="!showForm&&isMB">
        <el-divider style="margin:0px;"></el-divider>
        <el-form :class="{'form-item':true, 'form-item-left':isMB}" @keyup.enter.native="getData()">
          <el-form-item label="审批状态">
            <el-select v-model="params.Status" placeholder="请选择状态" clearable>
              <!-- <el-option label="草稿" :value="0"></el-option> -->
              <el-option label="审批中" :value="1"></el-option>
              <el-option label="已通过" :value="2"></el-option>
              <el-option label="已驳回" :value="3"></el-option>
              <el-option label="已撤销" :value="4"></el-option>
              <el-option label="通过后撤销" :value="5"></el-option>
              <el-option label="异常" :value="6"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <el-row style="margin-bottom: 10px;" type="flex" justify="end">
      <el-col :span="isMB?6:3">
        <!-- <span class="span-top-text" style="white-space: nowrap;">列表信息</span> -->
      </el-col>
      <el-col :span="isMB?18:21">
        <div style="text-align: right;">
          <el-badge :value="endCount" :hidden="endCount==0" class="end-badge">
            <el-button type="primary" plain @click="toEnd">待销假</el-button>
          </el-badge>
          <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        </div>
      </el-col>
    </el-row>
    <div class="wf-tb">
      <div class="tb-row" v-for="(i,key) in data" :key="key" @click="mbDetails(i)">
        <div style="position: relative;">
          <div v-if="!isMB" style="position: absolute;right: 10px;">
            <el-button type="text" @click="details(i)">查看</el-button>
          </div>
          <div class="tb-item">
            <div class="i-label">{{i.Title}}</div>
            <div class="i-value">
              <el-tag class="my-tag" size="small" type="primary" v-if="i.Status==1">审批中</el-tag>
              <el-tag class="my-tag" size="small" type="success" v-if="i.Status==2">已通过</el-tag>
              <el-tag class="my-tag" size="small" type="danger" v-if="i.Status==3">已驳回</el-tag>
              <el-tag class="my-tag" size="small" type="info" v-if="i.Status==4">已撤销</el-tag>
              <el-tag class="my-tag" size="small" type="info" v-if="i.Status==5">通过后撤销</el-tag>
              <el-tag class="my-tag" size="small" type="danger" v-if="i.Status==6">异常</el-tag>
              <el-tag class="my-tag" size="small" type="info" v-if="i.NodeName">{{i.NodeName}}</el-tag>
            </div>
          </div>
        </div>
        <div>
          <template v-for="(ci,ckey) in i.FormItems">
            <template v-if="ci.IsPublic&&ci.FuncType>0">
              <div :key="ckey" class="tb-item" :class="{'is-mb':isMB}">
                <div class="i-label">{{ci.ItemName}}：</div>
                <div class="i-value" v-if="ci.ItemType==400">
                  <template v-for="(a,akey) in ci.FormItemValue.split('--|--')">
                    <span class="attach" :key="akey" @click.stop="download(a)">{{a.split('--@--')[1]}}</span>
                  </template>
                </div>
                <div class="i-value long-text" v-else-if="ci.ItemName=='请假事由'">
                  <span>{{ci.FormItemValue}}</span>
                </div>
                <div class="i-value" v-else>
                  <span v-if="ci.FormItemValue==''">无</span>
                  <template v-else>
                    <span>{{ci.FormItemValue}}</span>
                    <span v-if="ci.ItemName=='请假时长'">天</span>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <div class="no-data" v-if="data.length==0">
        <span>暂无数据</span>
      </div>
    </div>
    <el-dialog title="查看图片" :width="isMB?'90%':''" :visible.sync="imgVisible" append-to-body>
      <img width="100%" :src="imgUrl" alt />
    </el-dialog>
    <el-pagination
      v-if="!isMB"
      background
      layout="total, prev, pager, next, jumper"
      :page-size.sync="params.PageSize"
      :current-page.sync="params.PageIndex"
      :total="total"
      @size-change="getData"
      @current-change="getData"
    />
    <van-button v-else class="pageBn" @click="showPage=true">
      第 {{params.PageIndex}} 页
      <van-icon class="pageIcon" name="arrow-down" />
    </van-button>
    <van-popup v-model="showPage">
      <van-picker
        style="width:300px;"
        :columns="columns"
        @confirm="changePage"
        :default-index="0"
        show-toolbar
        @cancel="showPage=false"
        cancel-button-text="取消"
        confirm-button-text="确认"
        visible-item-count="3"
      />
    </van-popup>
    <div style="height: 10px;"></div>
    <add-dialog ref="addDialog" @close-saved="getData" />
    <details-dialog ref="detailsDialog" @close-saved="getData" />
  </div>
</template>
<script>
import addDialog from "./addDialog";
import detailsDialog from "./detailsDialog";
export default {
  components: { addDialog, detailsDialog },
  props: {
    endCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      api: require("@/api/wf/instance").default,
      data: [],
      showForm: !this.$store.state.isMB,
      total: 0,
      params: {
        ProcessId: null,
        ProcessName: "",
        Title: "",
        ApplyStartDate: null,
        ApplyEndDate: null,
        CompleteStartDate: null,
        CompleteEndDate: null,
        Status: null,
        PageIndex: 1,
        PageSize: 10,
      },
      isMB: this.$store.state.isMB,
      Processes: [],
      showPage: false,
      columns: [],
      imgVisible: false,
      imgUrl: "",
    };
  },
  methods: {
    resetQuery() {
      this.params.Status = null;
      this.params.ProcessId = null;
      this.params.ProcessName = "";
      this.params.Title = "";
      this.params.ApplyStartDate = null;
      this.params.ApplyEndDate = null;
      this.params.CompleteStartDate = null;
      this.params.CompleteEndDate = null;
      this.params.PageIndex = 1;
      this.params.PageSize = 10;
      // this.$refs.picker1.clear();
      // this.$refs.picker2.clear();
      this.getData();
    },
    setDate(data, type) {
      this.params[type + "StartDate"] = data.Start;
      this.params[type + "EndDate"] = data.End;
    },
    onQuery() {
      this.params.PageIndex = 1;
      this.params.PageSize = 10;
      this.getData();
    },
    getData() {
      this.$store.dispatch("getWorkbench");
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.api.getMyInstanceWithFormList(params).then((res) => {
        if (res.Code == 0) {
          this.total = res.Count;
          this.data = res.Data;

          let times = Math.ceil(res.Count / this.params.PageSize);
          if (times == 0) times = 1;
          this.columns = [];
          for (var i = 0; i < times; i++) {
            this.columns.push("第 " + (i + 1) + " 页");
          }
          if (this.Processes.length == 0) this.getProcess();
        } else this.$message.error(res.Msg);
      });
    },
    getProcess() {
      this.api.getMyProcesses().then((res) => {
        this.Processes = res.Data;
      });
    },
    toEnd() {
      this.$router.push("/wf/leave?onEnd=true");
    },
    create() {
      console.log("create");
      this.$refs.addDialog.openCreate().then((that) => {
        that.Processes = this.Processes;
      });
    },
    mbDetails(data) {
      if (this.isMB) this.details(data);
    },
    details(row) {
      this.$refs.detailsDialog.openDetails(row);
    },
    changePage(e) {
      // console.log("pageNo", e.length);
      if (e.length == 5) {
        this.params.PageIndex = Number(e[2]);
      } else if (e.length == 6) {
        this.params.PageIndex = Number(e[2] + e[3]);
      }
      this.showPage = false;
      this.getData();
    },
    download(item) {
      var url = item.split("--@--")[0];
      var name = item.split("--@--")[1];
      var ext_list = name.split(".");
      var ext = ext_list[ext_list.length - 1];
      console.log("name", name);
      console.log("ext", ext);

      if (ext == "jpg" || ext == "png" || ext == "jpeg") {
        this.imgUrl = location.protocol + "//" + location.host + "/api" + url;
        console.log("imgUrl", this.imgUrl);
        this.imgVisible = true;
        return;
      }
      if (ext == "pdf") {
        if (this.chrome) {
          var href = location.protocol + "//" + location.host + "/api" + url;
          window.open(href, "_blank");
          return;
        }
      }

      const elink = document.createElement("a");
      elink.download = name;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + url;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
  },
};
</script>
<style lang="scss">
.end-badge {
  margin-right: 15px;
  .el-badge__content {
    line-height: 16px;
  }
}
</style>
<style lang="scss" scoped>
.searchIcon {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #aaa;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  margin-left: 4px;
  @media screen and (min-width: 768px) {
    &:hover {
      cursor: pointer;
      color: #fff;
      background: #409eff;
    }
  }

  i {
    transition-duration: 0.2s;
  }
  .el-icon-arrow-down {
    vertical-align: -1px;
  }
}
.wf-tb {
  margin-bottom: 10px;
  border: 1px solid #ebeef5;
  .tb-row {
    width: 100%;
    padding: 0 10px;
    font-size: 16px;
    color: #606266;
    .tb-item {
      display: inline-block;
      padding: 0 10px;
      line-height: 30px;
      .i-label {
        float: left;
      }
      .i-value {
        float: right;
        white-space: nowrap; //保证文本内容不会自动换行，如果多余的内容会在水平方向撑破单元格。
        overflow: hidden; //隐藏超出单元格的部分。
        text-overflow: ellipsis; //将被隐藏的那部分用省略号代替。
        .attach {
          color: #409eff !important;
          cursor: pointer;
        }
        .attach:not(:last-child)::after {
          content: "、";
        }
        .my-tag {
          margin-left: 7px;
          font-size: 15px;
        }
        .my-tag + .my-tag {
          margin-left: 7px;
        }
      }
      .long-text {
        max-width: 500px !important;
      }
    }
    .is-mb {
      width: 100%;
      .i-value {
        max-width: 70%;
      }
    }
  }
  .tb-row + .tb-row {
    border-top: 1px solid #ebeef5;
  }
}
.no-data {
  font-size: 13px;
  line-height: 60px;
  text-align: center;
  color: #606266;
}
</style>